var PhxCheckout = (function (PhxCheckout) {
    //Import modules only for jest.
    if(typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
        const logger = require('./logger')
        const threeDSecureHelper = require('./threeDSecureHelper');  
        const creditCardValidationHelper = require('./creditCardValidationHelper');   
        Object.assign(PhxCheckout, creditCardValidationHelper, logger, threeDSecureHelper)
    }
    //Polyfill for Object.assign
    if (typeof Object.assign !== 'function') {
        // Must be writable: true, enumerable: false, configurable: true
        Object.defineProperty(Object, "assign", {
            value: function assign(target, varArgs) { // .length of function is 2
                'use strict';
                if (target === null || target === undefined) {
                    throw new TypeError('Cannot convert undefined or null to object');
                }

                var to = Object(target);

                for (var index = 1; index < arguments.length; index++) {
                    var nextSource = arguments[index];

                    if (nextSource !== null && nextSource !== undefined) {
                        for (var nextKey in nextSource) {
                            // Avoid bugs when hasOwnProperty is shadowed
                            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                }
                return to;
            },
            writable: true,
            configurable: true
        });
    }

    /**
     * TODO: refer this from a global constant file.
     */
    PhxCheckout.cardTypes = {
        VISA: 'VI',
        MASTERCARD: 'MC',
        DISCOVER: 'DI',
        AMERICANEXPRESS: 'AX'
    };

    PhxCheckout.acceptedCreditCards = ["Visa", "MasterCard", "American Express", "Discover"];

    PhxCheckout.elementIds = {
        CREDIT_CARD_NUMBER: 'id_number',
        CREDIT_CARD_EXPIRATION_MONTH: 'id_expirationMonth',
        CREDIT_CARD_EXPIRATION_YEAR: 'id_expirationYear',
        CREDIT_CARD_SECURITY_CODE: 'id_securityCode',
        IBAN: 'id_iban',
        ACCOUNT_HOLDER: 'id_accountHolder',
        POSTAL_CODE: 'id_postalCode'
    };

    PhxCheckout.requestType = {
        VALID_REQUEST: 'VALID_REQUEST',
        INVALID_REQUEST: 'INVALID_REQUEST',
        DUPLICATE_REQUEST: 'DUPLICATE_REQUEST'
    };

    /*
     * flag used to determine if payment aut is in progress
     */
    PhxCheckout.paymentAuthInProgress = false;

    PhxCheckout.handleZeroStatusCode = false;

    PhxCheckout.JWTData = {};

    var defaultPosSubmitTimeout = 10000;  //10 sec default timeout unless optTimeout argument is supplied.
    var posResponseTextMsgLenMax = 200;   //New Relic has issues logging long messages.

    var cvvInputTimeout;                  //Holds timer id for cvv input.
    var cvvTypingValidationDelay = 1000;  //1 second delay between when user types inside cvv field and when we are running validation routines.
    var assetUrl


    /**
     * Checkout helper object
     */
    PhxCheckout.checkoutHelper = function () {

        // Test autofill data - loaded at runtime to avoid exposing credit card numbers in minified builds
        var AUTOFILL_TEST_DATA = {
            cardNumber: '',
            month: '',
            cvv: '',
            postal: ''
        };
        function _setAssetURL(url){
            assetUrl = url;
        }
        // Fetch test data config from CDN if deployed, otherwise use local path
        function _loadTestDataConfig() {
            var configUrl = (assetUrl || '/') + 'static/test-data-config.json';
            return fetch(configUrl)
                .then(function(response) { return response.json(); })
                .then(function(config) {
                    if (config && config.testCreditCard) {
                        AUTOFILL_TEST_DATA.cardNumber = config.testCreditCard.cardNumber;
                        AUTOFILL_TEST_DATA.month = config.testCreditCard.month;
                        AUTOFILL_TEST_DATA.cvv = config.testCreditCard.cvv;
                        AUTOFILL_TEST_DATA.postal = config.testCreditCard.postal;
                    }
                });
        }

        var payload = {};
        var paymentType = '';
        var zipUntouched = true;


        //TODO: Create new input with inputType and replace existing input
        function _togglePostalCode(show, inputType) {
            var postalCodeDiv = document.getElementById('postalCode');
            var display = show ? 'inline-block' : 'none';
            postalCodeDiv.style.display = display;
        }

        function _setPaymentType(value) {
            paymentType = value;
            if (paymentType === "CreditCard") {
                document.getElementById("dd_id").style.display = "none";
                document.getElementById("cc_id").style.display = "block";
            } else if (paymentType === "DirectDebit") {
                document.getElementById("dd_id").style.display = "block";
                document.getElementById("cc_id").style.display = "none";
                document.getElementById("id_iban").focus();
            }
        }

        function _getMaskedAccountNumber() {
            // example of result: ***********0005
            var creditCardNumber = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_NUMBER);
            var output = '';
            if (creditCardNumber) {
                creditCardNumber = creditCardNumber.value.replace(/ /g, '');

                //replace all numbers to asterisks except last 4
                var inputLength = creditCardNumber.length - 4;

                for (var l = 1; l <= inputLength; l++) {
                    output += '*';
                }
                //extract last four characters from the end
                output += creditCardNumber.substr(-4);
            }
            return output
        }

        function _getMaskedIBAN() {
            var ibanNumber = document.getElementById(PhxCheckout.elementIds.IBAN);
            return ibanNumber ? ibanNumber.value.replace(/ /g, '').substr(-4) : '';
        }


        var _toggleCardTypeIcons = function (toggle) {
            PhxCheckout.showCardTypeIcons = toggle;
            if (!toggle) {
                document.getElementById('cardTypeContainer').style.display = 'none';
            }
        }

        function _showCardImage(event) {
            if (!PhxCheckout.showCardTypeIcons) return;
            var activeCard = _getCardType();
            var CARD_IDS = {
                VI: 'visaCard',
                MC: 'masterCard',
                AX: 'amExpCard',
                DI: 'discoverCard'
            };
            var activeCardId = CARD_IDS[activeCard];
            var value = event.value;
            var isMobileView = document.body.clientWidth < 450;

            for (var key in CARD_IDS) {
                if (CARD_IDS.hasOwnProperty(key)) {
                    var cardId = CARD_IDS[key];
                    var element = document.getElementById(cardId);
                    if (isMobileView) {
                        if (activeCardId === cardId) {
                            element.style.display = 'block';
                        } else {
                            element.style.display = 'none';
                        }
                    } else {
                        if (!activeCardId || activeCardId === cardId || value.length === 0) {
                            element.style.display = 'inline-block';
                        } else if (value.length !== 0) {
                            element.style.display = 'none';
                        }
                    }
                }
            }
        }

        function _getCardType() {
            var creditCardNumberElement = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_NUMBER);
            crediCardFirstNumber = creditCardNumberElement ? creditCardNumberElement.value[0] : '';
            switch (crediCardFirstNumber) {
                case '4':
                    return PhxCheckout.cardTypes.VISA;
                case '2':
                case '5':
                    return PhxCheckout.cardTypes.MASTERCARD;
                case '6':
                    return PhxCheckout.cardTypes.DISCOVER;
                case '3':
                    var patterns = {
                        "AmEx": /^3[47]/,
                        "Discover": /^(30[0-5]|3095|3088|3112|3158|3337|36|3[8-9]|(35(?:28|29|[3-8][0-9])))/ // JCB and Diner Club Credit cards
                    }

                    for (var key in patterns){
                        if (patterns[key].test(creditCardNumberElement.value)) {
                            if (key === "AmEx"){
                                return PhxCheckout.cardTypes.AMERICANEXPRESS;
                            } else if ((key === "Discover")) {
                                return PhxCheckout.cardTypes.DISCOVER;
                            }
                        }
                    }

                    //default to AmEx
                    return PhxCheckout.cardTypes.AMERICANEXPRESS;
                default:
                    return '';
            }
        }

        function _getExpirationMonth() {
            var expirationMonthElement = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_EXPIRATION_MONTH),
                expirationMonth;
            // Differntiates between dropdown and textbox based on the flow
            if (expirationMonthElement && expirationMonthElement.nodeType === 'SELECT') {
                expirationMonth = expirationMonthElement.options[expirationMonthElement.selectedIndex].text;
            } else if (expirationMonthElement) {
                expirationMonth = expirationMonthElement.value;
            }
            return expirationMonth;
        }

        function _getExpirationYear() {
            var expirationYearElement = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_EXPIRATION_YEAR),
                expirationYear;
            if (expirationYearElement && expirationYearElement.nodeType === 'SELECT') {
                expirationYear = expirationYearElement.options[expirationYearElement.selectedIndex].text;
            } else if (expirationYearElement) {
                expirationYear = expirationYearElement.value;
            }

            if (expirationYear.length === 2) {
                expirationYear = '20' + expirationYear;
            }

            return expirationYear;
        }

        /**
         * _getCreditCardInfo
         *
         * returns all the required credit card information.
         */
        function _getCreditCardInfo() {
            return {
                maskedCardNumber: _getMaskedAccountNumber(),
                expirationMonth: _getExpirationMonth(),
                expirationYear: _getExpirationYear(),
                cardType: _getCardType()
            };
        }

        /**
         * _getDirectDebitInfo
         *
         * returns all the required direct debit information.
         */
        function _getDirectDebitInfo() {
            return {
                maskedIBAN: '****' + _getMaskedIBAN()
            };
        }

        function _getPostalCode() {
            var postalElement = document.getElementById('id_postalCode');
            return postalElement.value;
        }

        /**
         * _sendCardTypeToParent
         *
         * Sends card type to the parent
         */
        function _sendCardTypeToParent() {
            var cardType = _getCardType(),
                payload = {
                    action: 'CARDTYPEEVENT',
                    data: cardType
                };
            PhxCheckout.messenger.postMessageToParent(payload);
        }

        function _sendPaymentIdToParent() {
            var data = {};
            var query = window.location.search.substring(window.location.search.indexOf('&') + 1);
            var queryparams = query.split("&");
            for (var i = 0; i < queryparams.length; i++) {
                var pair = queryparams[i].split("=");
                data[pair[0]] = pair[1];
            }
            var payload = {
                action: 'PAYMENTIDEVENT',
                data: data
            };
            PhxCheckout.messenger.postMessageToParent(payload);
        }

        function _ping() {
            var payload = { action: 'PING' };
            PhxCheckout.messenger.postMessageToParent(payload);
        }

        function _sendPaymentTypeToParent() {
            payload = {
                action: 'PAYMENTTYPEEVENT',
                data: 'PayPal'
            };
            PhxCheckout.messenger.postMessageToParent(payload);
        }

        function _appendDataToForm(form, data) {
            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    var ff = document.createElement("input");
                    ff.name = key;
                    ff.id = key;
                    ff.type = "hidden";
                    ff.value = data[key];
                    form.appendChild(ff);
                }
            }
        }


        /* SDE POS data handling begins.
           _ajaxPostRequest(): Helper function.
        */
        function _ajaxPostRequest(url, data, resultHandler, optTimeout, headers) {
            var params = typeof data == 'string' ? data : Object.keys(data).map(
                function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
            ).join('&');

            var localWindow = PhxCheckout.util.getWindow();
            var xhr = localWindow.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
            var requestStartTime = new Date().getTime();      //Calculates response time.

            var resultHandlerCalled = false;                  //Optimization: flag to indicate if result handler has already been called
            //(onerror() case for handling network-level failures).

            var shouldCallResultHandler = true;

            xhr.open('POST', url);
            xhr.timeout = optTimeout;
            xhr.onreadystatechange = function () {
                try {
                    if(xhr.status === 0) {
                        // During timout issue resulthandler is called multiple times in onreadystatechange and ontimeout handler function
                        // Due to this behaviour we end up in calling multiple FCI in checkout stack. So to handled this we sent a flag from checkout
                        // Based on the flag value we will decide whether we should call resulthandler in onreadystatechange when status is 0
                        shouldCallResultHandler = !PhxCheckout.handleZeroStatusCode;
                    }

                    if (xhr.readyState === 4 && shouldCallResultHandler) {             //Pass all completed responses - 200, 400, 418 and 500 status codes.
                        resultHandler(_createTokenResponse(xhr.status === 200, (xhr.status === 200) ? 'success' : 'error',
                            xhr.status, xhr.responseText, requestStartTime));
                        resultHandlerCalled = true;
                    }
                } catch (e) {   //Handle additional cases (https://developer.mozilla.org/en-US/docs/AJAX/Getting_Started)
                    resultHandler(_createTokenResponse(false, 'xhr failed', 0, JSON.stringify(e), requestStartTime));
                    resultHandlerCalled = true;
                }
            };

            //Log timeout.
            xhr.ontimeout = function () {
                resultHandler(_createTokenResponse(false, 'timeout', xhr.status, xhr.responseText, requestStartTime));
            };

            //Catch additional errors that are at the network level (only if not already caught via onreadystatechange()).
            xhr.onerror = function (e) {
                if (!resultHandlerCalled)
                    resultHandler(_createTokenResponse(false, 'error', xhr.status, xhr.responseText, requestStartTime));
            };

            xhr.setRequestHeader('Accept', 'application/json');
            xhr.setRequestHeader('Content-type', 'application/json');             
            if (!!headers) {
                for (var key in headers) {
                    //since clientPath is added below we can skip here otherwise it will be added two times
                    if(key === 'Ancestry-ClientPath') {
                       continue;
                    }
                    xhr.setRequestHeader(key, headers[key])
                }
            }
            
            //adding clientpath in request headers to be identified where request is made from pci-frame
            var ancestryClientPath = headers && headers['Ancestry-ClientPath'] ? headers['Ancestry-ClientPath'] + ':' : '';
            xhr.setRequestHeader('Ancestry-ClientPath', ancestryClientPath + 'phoenix-pciiframe');

            xhr.send(params);

            return xhr;
        }

        /* createTokenResponse(): returns a message object ready for logging and sending back to the parent window.
           Note:
           responseText is reduced to posResponseTextMsgLenMax size as excess size causes none of the text to appear in NR logs.
        */
        function _createTokenResponse(success, opResultText, responseStatus, responseText, requestStartTime) {
            return {
                success: success,
                responseText: (responseText !== null && responseText.length > 0) ? responseText : '',
                responseStatus: responseStatus,
                opResultText: opResultText,
                opResponseTime: new Date().getTime() - requestStartTime
            };
        }

        function _submitSde3dsData(data) {
            //
            // avoids duplicate authorization calls when double clicks are not propely
            // handled at the calling application.
            //
            if (PhxCheckout.paymentAuthInProgress) {
                return _getSdeSyncResponse(PhxCheckout.requestType.DUPLICATE_REQUEST);
            }

            if(data.hasOwnProperty('handleZeroStatusCode')) {
                PhxCheckout.handleZeroStatusCode = data.handleZeroStatusCode
            }

            // Adds optional timeout as a parameter.
            var optTimeout = (typeof data.optTimeout === 'undefined') ? defaultPosSubmitTimeout : data.optTimeout;

            var payload = data.payload;
            var endpoint = data.endpoint;
            var headers = data.headers;

            //Additional log data to help us identify response failures to request data.
            var correlationLogData = {
                userId: typeof payload.userId === 'undefined' ? '' : payload.userId,
                locale: typeof payload.locale === 'undefined' ? '' : payload.locale
            };

            try {
                payload = _createSubmitSdePayload(payload);
                // set to avoid duplicate authorizations
                PhxCheckout.paymentAuthInProgress = true;

                PhxCheckout.logger.logEventToServer("iFramePostPosData", {
                    posType: "SDE",
                    posEndpoint: endpoint,
                    isFargate: window.isFargate,
                    posUserId: correlationLogData.userId,
                    posLocale: correlationLogData.locale,

                    posAction: "preAjaxRequest",
                    posResult: "",
                    posResultCode: "",
                    posResultMsg: ""
                });

                _submitSde(payload, endpoint, optTimeout, headers, correlationLogData);
            } catch (error) {
                PhxCheckout.paymentAuthInProgress = false;
            }
            //Sync return to match form post return.
            return _getSdeSyncResponse(PhxCheckout.requestType.VALID_REQUEST);
        }

        // Posts data to SDE POS and emits message back
        // to parent frame to continue the pmt flow.
        function _submitSdeData(data, skipSetup) {
            try {
                //
                // avoids duplicate authorization calls when double clicks are not propely
                // handled at the calling application.
                //
                PhxCheckout.SDEData = data;
                if(data.hasOwnProperty('handleZeroStatusCode')) {
                    PhxCheckout.handleZeroStatusCode = data.handleZeroStatusCode
                }

                if (PhxCheckout.paymentAuthInProgress) {
                    return _getSdeSyncResponse(PhxCheckout.requestType.DUPLICATE_REQUEST);
                }

                if (!skipSetup) {
                    // if initial call then clear JWT data
                    PhxCheckout.JWTData = {};
                }

                var commonNrData = {};
                // Adds optional timeout as a parameter.
                var optTimeout = (typeof data.optTimeout === 'undefined') ? defaultPosSubmitTimeout : data.optTimeout;
                var payload = data.payload;

                var shouldCall3dsSetup = payload.threeDSEnabled && !skipSetup && paymentType === 'CreditCard';
                var endpoint = data.endpoint;

                if (shouldCall3dsSetup && endpoint && endpoint.indexOf('?') !== -1) {
                    endpoint = endpoint.replace("?", "/setup?");
                } else if (shouldCall3dsSetup) {
                    endpoint += '/setup'
                }

                var headers = data.headers;
                payload = _createSubmitSdePayload(payload);

                //Additional log data to help us identify response failures to request data.
                var correlationLogData = {
                    userId: typeof payload.userId === 'undefined' ? '' : payload.userId,
                    locale: typeof payload.locale === 'undefined' ? '' : payload.locale
                };


                var nrName = shouldCall3dsSetup ? 'iFrame3dsSetup' : 'iFramePostPosData';

                //Adds logging for the SDE request.
                commonNrData = {
                    posType: "SDE",
                    posEndpoint: endpoint,
                    isFargate: window.isFargate,
                    posUserId: correlationLogData.userId,
                    posLocale: correlationLogData.locale,

                    posAction: "preAjaxRequest",
                    posResult: "",
                    posResultCode: "",
                    posResultMsg: "",
                    cardType: _getCardType()
                }

                PhxCheckout.logger.logEventToServer(nrName, commonNrData);

                // set to avoid duplicate authorizations
                PhxCheckout.paymentAuthInProgress = true;

                if (shouldCall3dsSetup) {
                    try {
                        _ajaxPostRequest(
                            endpoint,
                            JSON.stringify(payload),
                            function (response) {
                                var nrObject = Object.assign({}, commonNrData, {
                                    posResult: response.opResultText,
                                    posResultCode: response.responseStatus,
                                    posResultMsg: (response.responseText !== null && response.responseText.length > 0) ? response.responseText.substr(0, posResponseTextMsgLenMax) : '',
                                    posResponseTime: response.opResponseTime
                                })

                                if (response.success) {
                                    try {
                                        var parsedResponse = JSON.parse(response.responseText);
                                        PhxCheckout.JWTData = parsedResponse;
                                        PhxCheckout.logger.logEventToServer(nrName, Object.assign({}, nrObject, { posAction: 'ajaxRequestSuccess' }));
                                        _submitDDCForm();
                                    } catch (e) {
                                        PhxCheckout.paymentAuthInProgress = false;
                                        // todo: log failure
                                        PhxCheckout.threeDSecureHelper.relay3dsFailure(e);
                                        PhxCheckout.logger.logEventToServer(nrName, Object.assign({}, nrObject, { posAction: 'ajaxRequestFailure', posError: e && e.message }));
                                    }
                                } else {
                                    PhxCheckout.paymentAuthInProgress = false;
                                    PhxCheckout.threeDSecureHelper.relay3dsFailure();
                                    PhxCheckout.logger.logEventToServer(nrName, Object.assign({}, nrObject, { posAction: 'ajaxRequestFailure' }));
                                }
                            },
                            optTimeout,
                            headers
                        )
                    } catch (error) {
                        PhxCheckout.paymentAuthInProgress = false;
                        PhxCheckout.threeDSecureHelper.relay3dsFailure(error);
                        PhxCheckout.logger.logEventToServer(nrName, Object.assign({}, commonNrData, { posAction: 'ajaxRequestFailure', posError: error && error.message }));
                    }

                } else {
                    if (payload.threeDSEnabled) {
                        // if user is enrolled for 3DS, we need to pass access token and reference id to tokenize call
                        payload.accessToken = PhxCheckout.JWTData.accessToken;
                        payload.referenceId = PhxCheckout.JWTData.referenceId;
                    }
                    _submitSde(payload, endpoint, optTimeout, headers, correlationLogData)
                }
            } catch (error) {
                PhxCheckout.paymentAuthInProgress = false;
                var errorData = {
                    action: 'PAYMENTIDEVENT',
                    success: false,
                    opResultText: 'error',
                    responseText: JSON.stringify({ type: error.message }),
                    cardType: _getCardType()
                };
                PhxCheckout.logger.logEventToServer(nrName, Object.assign({}, commonNrData, { posAction: 'ajaxRequestFailure', posError: error && error.message }));
                PhxCheckout.messenger.postMessageToParent(errorData);
            }
            //Sync return to match form post return.
            return _getSdeSyncResponse(PhxCheckout.requestType.VALID_REQUEST);
        }

        function _submitSde(payload, endpoint, optTimeout, headers, correlationLogData) {
            try {
                _ajaxPostRequest(    //After SDE completes (async update).
                    endpoint,
                    JSON.stringify(payload),
                    function (response) {
                        // resets duplicate authorization flag afer SDE response
                        PhxCheckout.paymentAuthInProgress = false;

                        //Add additional data to the response back to the parent window for error handling.
                        var sdeData = {
                            action: 'PAYMENTIDEVENT',
                            success: response.success,
                            responseText: response.responseText,
                            responseStatus: response.responseStatus,
                            opResultText: response.opResultText,
                            opResponseTime: response.opResponseTime,
                            data: {},
                            cardType: _getCardType()
                        };
                        // once the request to submitSde has been made , reset the referenced data
                        _resetSdeData();
                        //Case 1: Successful ajax call but no wallet ID.
                        //Case 2: Failed ajax call (below).
                        if (response.success) {
                            try {
                                jResponse = JSON.parse(response.responseText);
                                sdeData.data.payment_id = jResponse.walletId;
                                sdeData.data.payment_site_id = jResponse.paymentSiteId;
                                if (jResponse.bin) {
                                    sdeData.data.bin = jResponse.bin;
                                }
                            } catch (e) {
                                if (PhxCheckout.logger.hasConsole()) {
                                    console.log('Response from SDE was successful but could not be parsed. ' + JSON.stringify(e));
                                }
                            }
                        } else if (payload.threeDSEnabled && response.responseStatus === 449) { // handling 449
                            try {
                                sdeData.data = JSON.parse(response.responseText);

                                if (sdeData.data && sdeData.data.paReq) {
                                    try {
                                        // decode base64 encoded paReq value and then parse JSON string
                                        var parsedData = JSON.parse(window.atob(sdeData.data.paReq));
                                        // get iframe challenge window size
                                        sdeData.data.challengeWindowSize = parsedData.challengeWindowSize;
                                    } catch (e) {
                                        sdeData.data.challengeWindowSize = 'default';
                                    }
                                }
                            } catch (e) {
                                if (PhxCheckout.logger.hasConsole()) {
                                    console.log('Response from SDE was failed and failure response could not be parsed. ' + JSON.stringify(e));
                                }
                            }
                        }

                        //Log to New Relic.
                        PhxCheckout.logger.logEventToServer('iFramePostPosData', {
                            posType: 'SDE',
                            posAction: 'ajaxRequest',
                            posResult: response.opResultText,
                            posResultCode: response.responseStatus,
                            posResultMsg: (response.responseText !== null && response.responseText.length > 0) ? response.responseText.substr(0, posResponseTextMsgLenMax) : '',
                            posUserId: correlationLogData.userId,
                            posLocale: correlationLogData.locale,
                            posResponseTime: response.opResponseTime,
                            isFargate: window.isFargate,
                            posEndpoint: typeof endpoint === 'undefined' ? '' : endpoint,
                            cardType: _getCardType()
                        });

                        PhxCheckout.messenger.postMessageToParent(sdeData);
                    },
                    optTimeout,
                    headers
                );
            }
            catch (e) {
                // once the request to submitSde has been made , reset the referenced data on error scenario
                _resetSdeData();
                // resets duplicate authorization flag for any uncaught errors
                PhxCheckout.paymentAuthInProgress = false;
            }

        }

        function _createSubmitSdePayload(payload) {
            if (paymentType === 'CreditCard') {
                var creditCardNumber = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_NUMBER);
                var cardNum = creditCardNumber.value.replace(/[^\d]+/g, '');

                var creditCardSecurityCode = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_SECURITY_CODE);
                var cvv = creditCardSecurityCode.value.replace(/[^\d]+/g, '');

                payload.card.cardNumber = cardNum;
                payload.card.cardType = _getCardType();
                payload.card.expirationYear = _getExpirationYear();
                payload.card.expirationMonth = _getExpirationMonth();
                payload.card.cvv = cvv;
            } else if (paymentType === 'DirectDebit') {
                var iban = document.getElementById(PhxCheckout.elementIds.IBAN).value.replace(/\s/g, '');
                payload.iban = iban;
            }
            return payload
        }

        function _submitDDCForm() {
            var ddcForm = document.querySelector('#ddc-form');
            var ddcInput = document.querySelector('#ddc-jwt');
            if (ddcForm && ddcInput) {
                ddcForm.setAttribute("action", PhxCheckout.JWTData.dataCollectionUrl);
                ddcInput.value = PhxCheckout.JWTData.accessToken;

                PhxCheckout.logger.logEventToServer('iFrame3dsDcc', { posAction: 'dccInit' });

                ddcForm.submit();
            }
        }

        function _ddciHandler(event) {
            if (!PhxCheckout.JWTData.dataCollectionUrl) return;

            var data;
            var pathArray = PhxCheckout.JWTData.dataCollectionUrl.split('/');
            var protocol = pathArray[0];
            var host = pathArray[2];
            var url = protocol + '//' + host;

            if (event.origin === url) {
                // Merchant received a message - data
                try {
                    data = JSON.parse(event.data);

                    PhxCheckout.paymentAuthInProgress = false;

                    if (data !== undefined && data.Status) {
                        /// Songbird ran DF successfully
                        // pass true to skip PTS setup call
                        PhxCheckout.logger.logEventToServer('iFrame3dsDcc', { posAction: 'dccSuccess', posResult: event.data });

                        // To handle multiple submitSde call retry with the same signature validate the referenced SDE data is avaliable or not. 
                        // If present only then continue with the submitSde call.
                        if (!PhxCheckout.SDEData) {
                            // logging the scenario where the validation has failed 
                            PhxCheckout.logger.logEventToServer('iFrame3dsDcc', { posAction: 'dccSubmit_retry', posResult: 'Skip the submitSde' });
                            return;
                            
                        }
                        else {
                            _submitSdeData(PhxCheckout.SDEData, true);
                        }
                    } else {
                        PhxCheckout.threeDSecureHelper.relay3dsFailure();
                        PhxCheckout.logger.logEventToServer('iFrame3dsDcc', { posAction: 'dccFailure', posResult: event.data });

                    }
                } catch (e) {
                    PhxCheckout.paymentAuthInProgress = false;
                    PhxCheckout.threeDSecureHelper.relay3dsFailure(e);
                    PhxCheckout.logger.logEventToServer('iFrame3dsDcc', { posAction: 'dccFailure', posResult: e.message });
                }
            }
        }

        function _getSdeSyncResponse(requestType) {
            requestType = requestType || PhxCheckout.requestType.VALID_REQUEST;
            var sdeSyncResponse;
            if (paymentType === 'CreditCard') {
                sdeSyncResponse = _getCreditCardInfo();
            } else if (paymentType === 'DirectDebit') {
                sdeSyncResponse = _getDirectDebitInfo();
            }

            sdeSyncResponse.requestType = requestType;
            return sdeSyncResponse;
        }
        /* SDE data handling ends. */


        function _submitForm(data) {
            //Adds logging for the classical POS submitform event.
            PhxCheckout.logger.logEventToServer('iFramePostPosData', {
                posType: 'Classical POS',
                posAction: 'submitForm',
                posResult: '',
                posResultCode: '',
                posResultMsg: '',
                posUserId: typeof data.ucdmid === 'undefined' ? '' : data.ucdmid,
                posLocale: typeof data.locale === 'undefined' ? '' : data.locale,
                offerUrl: typeof data.ApplicationUrl === 'undefined' ? '' : data.ApplicationUrl,
                isFargate: window.isFargate,
                posEndpoint: typeof data.endpoint === 'undefined' ? '' : data.endpoint
            });

            var posTokenForm = document.getElementById('posTokenForm');
            _appendDataToForm(posTokenForm, data);
            posTokenForm.submit();
            return _getCreditCardInfo();
        }


        function _autoSpace(obj, event) {
            var cardNum = obj.value;

            if (!cardNum || cardNum.length === 0) {
                return;
            }

            var leftSide = cardNum.slice(0, obj.selectionStart);
            var matches = leftSide.match(new RegExp(' ', 'gi'));
            var numLeftSpaces = matches ? matches.length : 0;
            var numLeftDigits = obj.selectionStart - numLeftSpaces;
            var numRightDigits = cardNum.length - numLeftDigits;
            var cardType = _getCardType();

            cardNum = cardNum.replace(/[^\d]+/g, '');
            var length = cardNum.length;

            var maxLength = 22;
            switch (cardType) {
                case PhxCheckout.cardTypes.DISCOVER:
                case PhxCheckout.cardTypes.VISA:
                    maxLength = 27;
                    break;
                case PhxCheckout.cardTypes.AMERICANEXPRESS:
                    maxLength = 19;
                    break;
            }

            if (cardNum === '') {
                obj.value = cardNum;
                return;
            } else if (cardType === PhxCheckout.cardTypes.AMERICANEXPRESS) {
                var P1 = cardNum.substr(0, 4);
                var P2 = cardNum.substr(4, 6);
                var P3 = cardNum.substr(10);
                cardNum = [P1, P2, P3].join("  ").replace(/ +$/, '');
                cardNum = cardNum.substr(0, maxLength);
            } else {
                cardNum = cardNum.match(new RegExp('.{1,4}', 'g')).join("  ");
                cardNum = cardNum.substr(0, maxLength);
            }

            var prevChar = obj.value[obj.selectionStart - 1];
            var currChar = obj.value[obj.selectionStart];
            var nextChar = obj.value[obj.selectionStart + 1];
            //check string discarding white space at end
            if (obj.value.replace(/ +$/, '') != cardNum) {
                obj.value = cardNum.substr(0, maxLength);


                var count = 0;
                for (var i = 0; i < cardNum.length; i++) {
                    var char = cardNum[i];
                    if (char != ' ') {
                        if (count === numLeftDigits) {
                            //special case with deleting spaces
                            if ((prevChar === ' ' || currChar === ' ') && nextChar != ' ' && event.code === 'Backspace') {
                                obj.setSelectionRange(i - 2, i - 2);
                            } else {
                                obj.setSelectionRange(i, i);
                            }
                            return;
                        }
                        count += 1;
                    }
                }
            }
        }

        function _checkIfExpDateValid(obj, event, tabToElement, maxLength) {
            if (PhxCheckout.creditCardValidationHelper.validateExpirationDate() === "OK") {
                _autoTab(obj, event, tabToElement, maxLength)
            }
          }

        function _checkIfExpMonthValid(obj, event, tabToElement, maxLength) {
            if (PhxCheckout.creditCardValidationHelper.validateExpirationMonth() === "OK") {
                _autoTab(obj, event, tabToElement, maxLength)
            }
        }

        function _checkIfCCNumberValid(obj, event, tabToElement) {
            if (PhxCheckout.creditCardValidationHelper.validateCreditCardNumber() === "OK") {
                _autoTab(obj, event, tabToElement, obj.value.length)
            }
        }

        function _autoTab(obj, event, tabToElement, maxLength) {
            //special case for shift tab events to not autofocus
            if ((event.code === 'Tab') || (event.code === 'ShiftLeft') || (event.code === 'ShiftRight')) {
                return;
            }
            if (obj.value.length >= maxLength) {
                document.getElementById(tabToElement).focus();
            }
        }

        function _displayCVCodeTooltip(obj) {
            if (obj.value.length) {
                var cardFirstNum = obj.value[0];
                var tooltip = document.getElementById('securityCodeTooltipContent');
                if (tooltip) {
                    tooltip.style.display = (cardFirstNum === '3') ? 'none' : '';
                    document.getElementById('securityCodeTooltipContentForAmExp').style.display = (cardFirstNum === '3') ? '' : 'none';
                }
                document.getElementById('contentCVCode').className = '';
            } else {
                document.getElementById('contentCVCode').className = 'noDisplay';
            }
        }

        function _toggleCalloutExternal(value) {
            var calloutBtnDimensions = document.getElementById('securityCodeHelpTrigger').getBoundingClientRect();
            var _calloutBtnDimensions = {};
            // firefox can't pass an object with methods via postMessage
            for (property in calloutBtnDimensions) {
                _calloutBtnDimensions[property] = calloutBtnDimensions[property];
            }

            //delete toJSON function because functions can't be passed through postMessages
            delete _calloutBtnDimensions.toJSON;
            payload = {
                action: 'TOGGLECALLOUTEVENT',
                data: {
                    'state': value,
                    'calloutBtnDimensions': _calloutBtnDimensions,
                    'validationMessageHeight': document.getElementById('ccValidationSuccess').clientHeight
                }
            };
            PhxCheckout.messenger.postMessageToParent(payload);
        }

        function _toggleCallout(state) {
            if (state === 1) {
                _setCallbackProperties();
            }

            var display = (state === 1) ? 'inline' : 'none';
            var wrapIframe = document.getElementById('calloutWrapIframe');

            wrapIframe.style.display = display;
        }

        function _getWindowWidth() {
            var localWindow = PhxCheckout.util.getWindow();
            return localWindow.innerWidth;
        }

        function _setCallbackProperties() {
            var outerCallout = document.getElementById('calloutWrapIframe');
            var calloutBtnDimensions = document.getElementById('securityCodeHelpTrigger').getBoundingClientRect();
            var ccErrors = document.getElementById('cc_errors_wrapper').style.display === 'inline-block' ? 1 : 0;

            var windowWidth = _getWindowWidth();
            if (windowWidth < 547) {
                outerCallout.className = 'callout calloutPositionLeft fadeIn';
                outerCallout.style.left = calloutBtnDimensions.left - 240;
            } else {
                outerCallout.className = 'callout calloutPositionRight fadeIn';
                outerCallout.style.left = calloutBtnDimensions.left + 22;
            }

            if (windowWidth < 380) {
                outerCallout.style.top = ccErrors ? '47px' : '15px';
            } else {
                outerCallout.style.top = ccErrors ? '30px' : '10px';
            }
        }

        function _forceNumeric(obj) {
            obj.value = obj.value.replace(/[^\d]+/g, '');
        }

        //only used to reset values for testing
        function _resetCcTransitionState() {
            _ccTransitionState = ''
        }


        /* _setCVVMaxLength(): sets maximum accepted length for CVV field depending on CC type.
           Also: if cvv field contains digits, run cvv validation to ensure that the length is
           still valid for that particular card.
        */
        function _setCVVMaxLength() {
            var cvvField = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_SECURITY_CODE);
            var maxLengthForCVV = PhxCheckout.creditCardValidationHelper.getCVVLengthForCreditCard();
            cvvField.setAttribute('maxLength', maxLengthForCVV);

            //Trim CVV length to fit the card spec.
            if (cvvField.value.length > maxLengthForCVV) {
                cvvField.value = cvvField.value.substring(0, maxLengthForCVV);
            }

            /* If there is a CVV already entered, validate it as the CC # could be changing.
               Even though the call is bit expensive for every stroke, we are using delayed version to
               throttle calls to validator while the user is typing.  Also the validation is almost instantenous
               and does not require user to tab out to see whether their CVV is valid or not after CC #.
            */
            if (cvvField.value.length > 0) {
                _validateSecurityCodeOnKeypress();
            }
        }


        //_validateSecurityCodeOnKeypress(): delayed validation until user stops typing for X milliseconds.
        function _validateSecurityCodeOnKeypress() {
            clearTimeout(cvvInputTimeout);

            cvvInputTimeout = setTimeout(function () {
                PhxCheckout.creditCardValidationHelper.validateSecurityCode();
            }, cvvTypingValidationDelay);
        }


        function _autoFill() {
            return _loadTestDataConfig().then(()=>{
                if (AUTOFILL_TEST_DATA.cardNumber) {
                    document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_NUMBER).focus();
                    document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_NUMBER).value = AUTOFILL_TEST_DATA.cardNumber;
                    document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_EXPIRATION_MONTH).focus();
                    document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_EXPIRATION_MONTH).value = AUTOFILL_TEST_DATA.month;
                    document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_SECURITY_CODE).focus();
                    document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_SECURITY_CODE).value = AUTOFILL_TEST_DATA.cvv;
                    var postal = document.getElementById(PhxCheckout.elementIds.POSTAL_CODE);
                    if (postal) {
                        postal.value = AUTOFILL_TEST_DATA.postal;
                    }

                    var year = (new Date().getFullYear() + 1).toString();
                    var yearElem = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_EXPIRATION_YEAR);
                    yearElem.focus()
                    if (yearElem.getAttribute('maxlength') === '2') {
                        year = year.substring(2)
                    }
                    yearElem.value = year;
            }
            })
        }

        function _computeToolTipHeight() {
            var tooltip = document.getElementById("calloutWrapIframe");

            if (!tooltip) {        //If tooltip is not found (i.e. Phoenix.html / Sage Team), return 0.
                return 0;
            }

            var toolTipHeight = tooltip.scrollHeight || 0;
            var toolTipStyle = window.getComputedStyle(tooltip) || { top: "0px" };
            var toolTipTop = toolTipStyle.top;
            toolTipTop = toolTipTop.replace(/\D/g, "");
            var toolTipComputedHeight = toolTipStyle.display !== 'none' ? parseInt(toolTipTop) + toolTipHeight : 0;
            return toolTipComputedHeight;
        };

        function _updateFrameSize() {
            var cartFrameEl = document.getElementById("expresscartIframe");
            var toolTipComputedHeight = _computeToolTipHeight();

            var calcHeight =
                cartFrameEl && cartFrameEl.scrollHeight
                    ? cartFrameEl.scrollHeight
                    : 150;
            var frameHeight = Math.max(toolTipComputedHeight, calcHeight) + "px";
            var payload = {
                action: "UPDATEFRAMESIZEEVENT",
                data: { height: frameHeight }
            };

            PhxCheckout.messenger.postMessageToParent(payload);
        }

        function _sendPostalCode(shipingZip) {
            if (!zipUntouched) return;
            document.getElementById('id_postalCode').value = shipingZip;
        }

        function _onPostalBlur() {
            zipUntouched = false;
        }

        function _resetSdeData() {
            PhxCheckout.logger.logEventToServer('resetSdeData');
            delete PhxCheckout.SDEData
            return;
        }

        return {
            autoSpace: _autoSpace,
            autoTab: _autoTab,
            displayCVCodeTooltip: _displayCVCodeTooltip,
            getCreditCardInfo: _getCreditCardInfo,
            getCardType: _getCardType,                  /* Information already returned as part of getCreditCardInfo. */
            setPaymentType: _setPaymentType,
            sendCardTypeToParent: _sendCardTypeToParent,
            toggleCardTypeIcons: _toggleCardTypeIcons,
            showCardImage: _showCardImage,
            sendPaymentTypeToParent: _sendPaymentTypeToParent,
            sendPaymentIdToParent: _sendPaymentIdToParent,
            setCVVMaxLength: _setCVVMaxLength,
            submitForm: _submitForm,
            createTokenResponse: _createTokenResponse,
            submitSdeData: _submitSdeData,
            toggleCallout: _toggleCallout,
            toggleCalloutExternal: _toggleCalloutExternal,
            forceNumeric: _forceNumeric,
            validateSecurityCodeOnKeypress: _validateSecurityCodeOnKeypress,
            autoFill: _autoFill,
            ping: _ping,
            getPostalCode: _getPostalCode,
            togglePostalCode: _togglePostalCode,
            onPostalBlur: _onPostalBlur,
            sendPostalCode: _sendPostalCode,
            checkIfExpDateValid: _checkIfExpDateValid,
            checkIfExpMonthValid: _checkIfExpMonthValid,
            checkIfCCNumberValid: _checkIfCCNumberValid,
            //testing only
            _resetCcTransitionState: _resetCcTransitionState,
            _computeToolTipHeight: _computeToolTipHeight,
            updateFrameSize: _updateFrameSize,
            ddciHandler: _ddciHandler,
            submitSde3dsData: _submitSde3dsData,
            loadTestDataConfig: _loadTestDataConfig,
            setAssetURL:_setAssetURL
        };
    }();

    return PhxCheckout;

}(PhxCheckout || {}));

if (window.addEventListener) {
    window.addEventListener("message", PhxCheckout.checkoutHelper.ddciHandler, false);
} else if (window.attachEvent) {
    window.attachEvent("message", PhxCheckout.checkoutHelper.ddciHandler);
}

if(typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
    module.exports = PhxCheckout //export it as module only for jest.
}